const dataFR = {
  readMore: "Lire la suite",
  prev: "Précédent",
  next: "Suivant",
  blogs: [
      {
        id: 1,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Qu'est-ce que l'IFU (Identifiant Financier Unique) ? Signification, Avantages et Processus d'Enregistrement",
        excerpt: "Numéro IFU, Identifiant Financier Unique, signification IFU, Qu'est-ce que l'IFU, numéro fiscal IFU, enregistrement IFU, avantages IFU, Comment obtenir l'IFU, IFU pour les entreprises, conformité IFU"
      },
      {
        id: 2,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Comment s'inscrire à l'IFU : Guide étape par étape pour les entreprises par Pestel & Partners",
        excerpt: "Processus d'inscription IFU, Comment s'inscrire à l'IFU, Inscription IFU en ligne, Demande IFU, Étapes d'inscription IFU, Documents pour l'inscription IFU, Inscription IFU pour entreprises, Guide d'inscription IFU"
      },
      {
        id: 3,
        image: "/assets/images/Blog/bloglist1.png",
        title: "LBC & Prévention de la Fraude dans la Fintech : Meilleures Pratiques pour Rester Conforme",
        excerpt: "LBC dans la fintech, Prévention de la fraude fintech, Conformité anti-blanchiment, Réglementations LBC, KYC et LBC, Détection de fraude fintech, Prévention de la criminalité financière, Fintech",
      },
      {
        id: 4,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Conseils en Cybersécurité pour les Startups Fintech : Expertises de Pestel & Partners",
        excerpt: "Cybersécurité fintech, Cybersécurité pour startups fintech, Meilleures pratiques de sécurité fintech, Gestion des cyber-risques, Protection des données fintech, Cybermenaces fintech, Sécurité de l'information fintech",
      },
      {
        id: 5,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Stratégies Financières Intelligentes pour les PME afin de Croître et d'Évoluer avec Succès",
        excerpt: "Stratégies financières pour les PME, Stratégies de croissance des PME, Stratégie financière d'entreprise, Gestion financière des PME, Gestion des flux de trésorerie des PME, Stratégies de mise à l'échelle des PME, Stratégies de rentabilité des PME",
      },
      {
        id: 6,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Conseils de Planification Financière pour les Petites et Moyennes Entreprises par Pestel & Partners",
        excerpt: "Planification financière pour les PME, Planification financière des petites entreprises, Budgétisation d'entreprise, Prévision financière, Gestion du fonds de roulement, Gestion des dépenses, Conseils de planification financière pour les PME",
      },
      {
        id: 7,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Pourquoi l'Audit est Important : L'Importance de l'Audit pour la Transparence des Entreprises",
        excerpt: "Importance de l'audit, Audit d'entreprise, Avantages de l'audit financier, Audit interne, Audit externe, Conformité d'audit, Transparence des entreprises",
      },
      {
        id: 8,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Stratégie Fiscale pour les Entreprises : Guide de Conformité et de Croissance par Pestel & Partners",
        excerpt: "Stratégie fiscale d'entreprise, Planification fiscale pour les entreprises, Conformité fiscale des sociétés, Optimisation fiscale des entreprises, Services de conseil fiscal, Réglementations fiscales pour les entreprises, Planification fiscale stratégique",
      },
      {
        id: 9,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Le Droit des Sociétés Simplifié : Exigences Légales que Chaque Entreprise Doit Respecter",
        excerpt: "Bases du droit des sociétés, Exigences légales des entreprises, Conformité des entreprises, Droit des sociétés, Gouvernance d'entreprise, Conformité légale pour les entreprises, Guide du droit des affaires",
      },
      {
        id: 10,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Création et Enregistrement d'Entreprise : Liste de Contrôle Juridique et Financière pour les Startups",
        excerpt: "Enregistrement d'entreprise, Constitution d'entreprise, Incorporation de société, Enregistrement de startup, Comment enregistrer une entreprise, Licence commerciale, Conformité des startups",
      },
    ],
};

export default dataFR;